import { Links } from 'types/links';

export const resctrictedPages: string[] = [
  Links.home,
  Links.updatePassword,
  Links.updateProfile,
];
